export default class DistributionListItemModel {
  id: string;
  name: string;
  users: string[];
  userCount: number;
  user_id: string;
  constructor(data: any) {
    this.id = data.id || undefined;
    this.name = data.name || undefined;
    this.user_id = data?.user_id || undefined;
    this.users = Array.isArray(data.users) ? data.users.map(u => u.id) : undefined;
    this.userCount = data.userCount || 0;
  }
}
